"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateWithSingleProp = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Takes a single prop value and binds it to local state in a functional component and updates local state when prop value changes.
 *
 * @template T
 * @param {T} propValue - React prop that should be bound to local state
 * @return {HookStateTuple<T>} Tuple containing [0] the reference to the state key which the React prop was bound to and [1] function for updating this key
 *
 * @example
 *
 *     const [ tempValue, setTempValue ] = useStateWithSingleProp(props.foo);
 */
var useStateWithSingleProp = function (propValue) {
    var _a = react_1.default.useState(propValue), value = _a[0], setStateValue = _a[1];
    // Update local state if propValue changes
    react_1.default.useEffect(function () {
        setStateValue(propValue);
    }, [propValue]);
    return [value, setStateValue];
};
exports.useStateWithSingleProp = useStateWithSingleProp;
